import { AppState } from 'src/config/appState';

import { CPProgramState } from '../models/cpProgram';

export const getCPProgramState = (state: AppState): CPProgramState => state.cpProgram;
